<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      top="8vh"
      append-to-body>
    <div slot="footer" style="text-align: left;">
      <el-button type="primary" size="mini" :loading="exportLoading" @click="exportData">导出明细</el-button>
    </div>
    <el-table
        :data="details"
        v-loading="loading"
        size="mini"
        height="60vh"
        border
        style="width: 100%">
      <template slot="empty">
        <div v-if="!loading">暂无明细数据</div>
      </template>
      <el-table-column type="index" label="序号" width="55" align="center"/>
      <el-table-column prop="factoryNo" align="center" label="出厂编号" min-width="140"/>
      <el-table-column prop="orderNumber" align="center" label="订单号" min-width="150"/>
      <el-table-column prop="invoiceNo" align="center" label="发货单号" min-width="150"/>
      <el-table-column prop="employeeName" align="center" label="销售员" width="100"/>
      <el-table-column prop="customerName" align="center" label="客户" min-width="160"/>
      <el-table-column prop="makingDate" align="center" label="下单日期" width="110"/>
      <el-table-column prop="invoiceTime" align="center" label="交期" width="110"/>
      <el-table-column
          prop="amount"
          align="center"
          label="金额(万元)"
          width="110"
          :formatter="amountFormatter"/>
      <el-table-column prop="productionState" align="center" label="排产状态" width="90"/>
      <el-table-column prop="completeEndState" align="center" label="发运状态" width="90"/>
      <el-table-column prop="invoiceReceiveStatus" align="center" label="签收状态" width="90"/>
      <el-table-column prop="workflowStatus" align="center" label="流程状态" width="110"/>
      <el-table-column prop="departmentName" align="center" label="区域" min-width="130"/>
    </el-table>
  </el-dialog>
</template>

<script>
  export default {
    name: "SalesRevenueDetailDialog",
    data() {
      return {
        dialogVisible: false,
        loading: false,
        exportLoading: false,
        title: "明细预览",
        details: [],
      };
    },
    methods: {
      amountFormatter(row, column, cellValue) {
        if (cellValue === null || cellValue === undefined || cellValue === "") {
          return "";
        }
        return (Number(cellValue) / 10000).toFixed(2);
      },
      open(title, details) {
        this.title = title || "明细预览";
        this.details = details || [];
        this.dialogVisible = true;
      },
      exportData() {
        let rows = this.details || [];
        if (rows.length === 0) {
          return this.$message.warning("没有可导出的明细数据");
        }
        this.exportLoading = true;
        this.$http
          .postForFile("basic", "sd/salesRevenueReport/exportDetail", rows)
          .then(resp => {
            this.exportLoading = false;
            let blob = new Blob([resp.data]);
            let fileName = decodeURI(resp.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
